"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountPasswordLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var login_1 = require("../../model/login");
var service_1 = require("../../../library/base/service");
var AccountPasswordLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AccountPasswordLogin, _super);
    function AccountPasswordLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '账号密码登录';
        _this.code = '101078';
        _this.desc = '账号密码登录';
        _this.requestParams = new login_1.AccountPasswordLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return AccountPasswordLogin;
}(service_1.BaseService));
exports.AccountPasswordLogin = AccountPasswordLogin;
//# sourceMappingURL=accountPasswordLogin.js.map